import store from '../store'
import {
  mapStateToProps as state,
  mapDispatchToProps as actions
} from '../components/ProgressBar/ProgressBar.state'

export default {
  incrementTime: 100,

  get state () {
    return state(store.getState())
  },

  add () {
    store.dispatch(actions.add())
  },

  increment () {
    store.dispatch(actions.increment())
  },

  setProgress (progress: number) {
    store.dispatch(actions.setProgress(progress))
  },

  remove () {
    store.dispatch(actions.remove())
  }
}
